module.exports = __webpack_public_path__ + "img/L_8S.b585c04a.png";